import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-contact-dialog',
	templateUrl: './contact-dialog.component.html',
	styleUrls: ['./contact-dialog.component.scss'],
})
export class ContactDialogComponent {
	@Input() contactFormShow: boolean = false;
	@Output() contactFormShowChange = new EventEmitter<boolean>();
	contactForm: FormGroup = this.formBuilder.group({
		FirstName: ['', Validators.required],
		FamilyName: ['', Validators.required],
		Company: [''],
		JobTitle: [''],
		Mail: ['', Validators.required],
		Phone: [''],
		Subject: ['', Validators.required],
		Content: [''],
	});

	constructor(private formBuilder: FormBuilder) {}

	onSubmitContact() {
		if (this.contactForm.invalid) return this.markAllCtrDirty(this.contactForm);

		const param = { ...this.contactForm.value };
		Object.keys(param).forEach((x) => (param[x] = param[x] ? param[x] : ''));
		const anchor = document.createElement('a');
		const target = 'bigaunt666@gmail.com';
		const cc = '';
		const bcc = '';

		const href = `mailto:${target}?
		cc=${cc}&
		bcc=${bcc}&
		subject=${param.Subject}&
		body=
			姓名：${param.FirstName} ${param.FamilyName}%0D%0A
			公司：${param.Company}%0D%0A
			職稱：${param.JobTitle}%0D%0A
			信箱：${param.Mail}%0D%0A
			電話：${param.Phone}%0D%0A
			問題與反應：${param.Content}
		`;

		anchor.href = href;
		anchor.click();
		this.contactFormShow = false;
	}

	markAllCtrDirty(form: FormGroup) {
		Object.keys(form.controls).forEach((key) => form.get(key).markAsDirty());
	}
}
